var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container menus"},[_c('van-cell-group',{staticClass:"menus__list"},[_c('van-cell',{attrs:{"icon":"label","title":"电子发票","size":"large","is-link":"","to":"invoice"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }